import { VanSelectionRoute } from '@/router/routes';
import store from '@/store';

export function createVanSelectionRoute(): string {
  return VanSelectionRoute + store.state.carTypeUrl;
}
